import 'isomorphic-fetch';
import { push, replace, goBack } from 'react-router-redux';

import { displayNotification } from 'Actions/UiActions';
import { trackGAEvent } from 'Actions/adsActions';

import { fetchForum, resetForum } from 'Actions/ForumviewActions';
import { fetchThread, resetThread } from 'Actions/ThreadviewActions';
import { fetchSearch, resetSearch } from 'Actions/SearchResultActions';
import { fetchMessages, resetMessages } from 'Actions/MessagesviewActions';
import { fetchUserProfile, resetUserProfile } from 'Actions/UserprofileActions';
import { resetOverlay } from 'Actions/UiActions';
import { updatePageNumber, resetInfinite } from 'Actions/InfiniteScrollActions'
import { resetGallery } from 'Actions/PhotoGalleryActions';
import { resetOnlineUsers, whoIsOnline } from 'Actions/OnlineUsersActions';
import { whatReleaseNotes, resetReleaseNotes } from 'Actions/ReleaseNotesActions';
import { fetchPortalPage, resetPortalPage } from 'Actions/PortalPageActions';
import { setCacheBuster } from 'Actions/MetaActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';
import { getLandingPage } from 'Actions/UserSettingsActions';

export const CLEAR_FIRST_LOAD = 'CLEAR_FIRST_LOAD';

export let lastGlobalAction = {
	type: null,
	data: {}
};

export function clearFirstLoad() {
	return {
		type: CLEAR_FIRST_LOAD
	}
}

export function setLastGlobalAction(type, data) {
	if(type && data){
		if (lastGlobalAction.type !== type) {
			lastGlobalAction = {
				type,
				data: {
					...data,
					page: parseInt( data.page ) || 1
				}
			};
		} else {
			lastGlobalAction = {
				type: type,
				data: Object.assign(
					lastGlobalAction.data,
					data, {
						forceRefresh: true,
						page: lastGlobalAction.data.page || parseInt( data.page )
					}
				)
			};
		}
	}
	return lastGlobalAction;
}

export function setLastGlobalPage( page ) {
	if( page ) {
		lastGlobalAction = {
			...lastGlobalAction,
			data: {
				...lastGlobalAction.data,
				page: parseInt( page )
			}
		};
	}
	return lastGlobalAction;
}

export function setGlobalNotification(dispatch, json, response) {
	if ( ( !json.message || json.message.length === 0 ) && response.status === 401 ) {
		displayNotification( 'warning', 'You don\'t have permissions to perform this action or you are not logged in. Please sign in and try again.' );
		// Record the Google Analytics event.
		dispatch( trackGAEvent( false, 'noPerms', 'error', 'user', response.status ) );

	} else if ( !json.message && response.status === 422 ) {
		displayNotification( 'warning', 'Username or Password is incorrect.' );
		// Record the Google Analytics event.
		dispatch( trackGAEvent( false, 'forumLoginFailed', 'error', 'user', response.status ) );

	} else if ( !json.message && !response.ok && response.name !== "TypeError" ) {
		displayNotification( 'warning', 'An error has occurred.' );
		// Record the Google Analytics event.
		dispatch( trackGAEvent( false, 'forumCommunication', 'error', 'system', ( response.status ? response.status : 0 ) ) );

	} else if ( !json.message && response.message && response.name ) {
		displayNotification( 'error', 'An error has occurred. ' + response.message );
		// Record the Google Analytics event.
		dispatch( trackGAEvent( false, 'serverCommunication', 'error', 'system', ( response.status ? response.status : 0 ) ) );
	}

	if( json && json.message && json.message.data ) {
		json.message.data.map( function( element ) {
			switch( element.type ) {
				case 'success':
					displayNotification( 'success', element.message, { force: true } );
					break;
				case 'info':
					displayNotification( 'info', element.message, { force: true } );
					break;
				case 'alert':
				case 'warning':
					displayNotification( 'warning', element.message, { force: true } );
					break;
				case 'error':
					displayNotification( 'error', element.message, { force: true } );
					// Record the Google Analytics event.
					dispatch( trackGAEvent( false, 'errorReturned', 'error', 'system' ) );
					break;
				default:
					break;
			}
		});
	}
}

export function backInHistory() {
	return ( dispatch ) => {
		if( lastGlobalAction.type !== null ) {
			dispatch( goBack() );
		} else {
			// Go to landing page
			let landingPage = dispatch( getLandingPage() );
			dispatch( push( landingPage ) );
		}
	};
}

export function exitTopify() {
	let domain = location.hostname;
	if(domain.indexOf("www.") === 0) {
		domain = domain.substr(4);
	}

	domain = "." + domain;

	let days90 = new Date(), days1 = new Date();
	days90.setTime( days90.getTime() + ( 90 * 86400000 ) ); // 90 days
	days1.setTime( days1.getTime() + ( 86400000 ) ); // 1 Day
	let expires90 = days90.toUTCString(), expires1 = days1.toUTCString();

	document.cookie = 'topify_hideAppView=1;expires='+expires90+';path=/;domain='+domain;
	document.cookie = 'topify_hidePrompt=1;expires='+expires1+';path=/;domain='+domain;

	// Record the Google Analytics event.
	this.props.dispatch( trackGAEvent(false, 'exitTopify', 'userAction', 'exit') );

	let redirectToUrl = location.origin + location.pathname;

	if(!redirectToUrl) {
		redirectToUrl = this.props.forum_url;
	}

	let urlSearch = window.location.search.replace( /\?/, '' ).replace( /rtemv=\d+/i, '' ).replace( /nocache=\d+/i, '' ).replace( /tfr=1/i, '' );

	window.location.href = redirectToUrl + '?' + urlSearch + ( urlSearch.length ? '&' : '' ) + 'nocache=' + Date.now();
	location.reload(true);

	return false;
}

export function refreshPage( manual = false ) {
	return function( dispatch ) {
		// Hide overlay and all opened stuff
		dispatch( resetOverlay() );
		// reset attachments gallery
		dispatch( resetGallery() );

		// We only want trigger analytics when we refresh manually
		if( manual ) {
			// Record the Google Analytics event.
			dispatch( trackGAEvent( false, `refresh_${ lastGlobalAction.type }`, 'userAction', 'consumption' ) );
		}

		// Update CacheBuster
		let cacheBust = new Date().getTime();
		dispatch( setCacheBuster( cacheBust ) );

		switch( lastGlobalAction.type ) {
			case 'forum':
				dispatch( resetInfinite() );
				dispatch( resetForum() );
				dispatch( fetchForum( lastGlobalAction.data, cacheBust ) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'thread':
				dispatch( resetInfinite() );
				dispatch( resetThread() );
				dispatch( fetchThread( lastGlobalAction.data, cacheBust ) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'search':
				dispatch( resetInfinite() );
				dispatch( resetSearch() );
				dispatch( resetForum() );
				dispatch( resetThread() );
				dispatch( fetchSearch( lastGlobalAction.data, cacheBust ) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'messages_pmroot':
			case 'messages_pmfolder':
			case 'messages_pm':
				dispatch( resetInfinite() );
				dispatch( resetMessages() );
				dispatch( fetchMessages( lastGlobalAction.data, cacheBust ) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'userprofile':
				dispatch( resetInfinite() );
				dispatch( resetUserProfile() );
				dispatch( resetForum() );
				dispatch( resetThread() );
				dispatch( fetchUserProfile( lastGlobalAction.data, cacheBust ) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'onlineUsers':
				dispatch( resetInfinite() );
				dispatch( resetOnlineUsers() );
				dispatch( whoIsOnline( lastGlobalAction.data.page, true) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'releaseNotes':
				dispatch( resetInfinite() );
				dispatch( resetReleaseNotes() );
				dispatch( whatReleaseNotes( lastGlobalAction.data.page, true) );
				dispatch( updatePageNumber( false, lastGlobalAction.data.page ) );
				break;

			case 'portalpage':
				dispatch( resetPortalPage() );
				dispatch( fetchPortalPage( { pagename: lastGlobalAction.data.pagename } ) );
				break;

			default:
				//noop
				break;
		}
	};
}

export function resetAll() {
	return function( dispatch ) {
		dispatch( resetInfinite() );
		dispatch( resetUserProfile() );
		dispatch( resetMessages() );
		dispatch( resetSearch() );
		dispatch( resetThread() );
		dispatch( resetForum() );
		dispatch( resetPortalPage() );
		dispatch( resetReleaseNotes() );
	}
}

export function pingServer() {
	return ( dispatch, getState ) => {
		const state = getState(),
			uid = state.ustate.id ? state.ustate.id : 0,
			url = state.topifyPresets.forumSite.url,
			config = dispatch( getFetchConfig() );

		return fetch( url + `?v=3.0&ajax=1&uid=${uid}&req=get&object=ping&_=${ new Date().getTime() }`, config ).then( ( response ) => {
				if( response.ok ) {
					response.json().then( ( json ) => {
						let result = responseNormalizer( json, false, {} );
						dispatch( updateUstate( json, result ) );
					} );
				}
			}
		);
	}
}

/**
 * Unified fetch config constructor function
 *
 * @param cacheBust
 * @param method
 * @param body
 * @param urlencoded
 *
 * @returns {function(*, *)} => {{method: string, mode: string, credentials: string, redirect: string, cache: string, body: *}}
 */
export function getFetchConfig( cacheBust = false, method = 'GET', body = null, urlencoded = true ) {
	return ( dispatch, getState ) => {
		let state = getState(),
			cache = ( cacheBust ? 'reload' : 'default' ),
			myHeaders = null;

		if( method === 'POST' ) {
			if( urlencoded ) {
				myHeaders = myHeaders || new Headers();
				myHeaders.append( "Content-Type", "application/x-www-form-urlencoded; charset=UTF-8" );
			}
		}

		// Check if we want to force cache busting
		try {
			if( state.routing.locationBeforeTransitions.query && parseInt( state.routing.locationBeforeTransitions.query.forceCacheBust ) === 1 ) {
				myHeaders = myHeaders || new Headers();
				myHeaders.append( 'pragma', 'no-cache' );
				myHeaders.append( 'cache-control', 'no-cache' );
				cache = 'reload';

				// remove the query string and replace url
				delete state.routing.locationBeforeTransitions.query.forceCacheBust;
				dispatch( replace( state.routing.locationBeforeTransitions ) );
			}

		} catch( e ) { /* ignore */ }

		let config = {
			method: method,
			mode: 'cors',
			credentials: 'include',
			redirect: 'follow',
			cache: cache,
		};

		if( method !== 'GET' && method !== 'HEAD' && body ) {
			config.body = body;
		}

		if( myHeaders ) {
			config.headers = myHeaders;
		}

		return config;
	}
}




// WEBPACK FOOTER //
// ./src/actions/GlobalMetaActions.js